export default "__VITE_ASSET__BnT1HxMD__"